import { combineReducers } from "redux";
// import * as authTypes from "../types/auth";
import auth from "./auth";
import general from "./general";

const appReducer = combineReducers({
  auth,
  general,
});

export default appReducer;
